'use strict';

/*
 * Truncate a string on a word boundary and add ellipses if it was truncated.
 * This filter truncates up to, but not including size.
 */

angular.module('msUtility').filter('truncate', function () {
  return function (string, size) {
    if (!string) {
      return string;
    }
    // default size 20
    size = size || 20;
    if (string.length < size) {
      return string;
    }
    while (string.length > size) {
      var idx = string.lastIndexOf(' ');
      if (idx === -1) {
        // failed to split at a word and still too long
        string = string.substr(0, size);
        break;
      }
      string = string.substr(0, idx);
    }
    // remove any punctuation at the end
    if (string.slice(-1).match(/[.,!\?;:\-]/)) {
      string = string.slice(0, -1);
    }
    return string + '…';
  };
});